import React from "react";
import { Link } from "react-router-dom";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import '../components/css/CourseStyle.css';
import Footer from '../components/Footer';
// import course1 from '../components/courses/csir-net1.png';
// import course2 from '../components/courses/csir-net2.png';
// import course3 from '../components/courses/csir-net3.png';
import tag from '../components/images/onlineTag.webp';
import banners from '../components/courses/csirnetcour.png';

function IITGate (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            
            <section className="bg-red text-white">
                <img src={banners} className="courseBanner" alt="" />
            </section>

            <section className="py-3">
                <div className="container">
                    <nav aria-label="breadcrumbs">
                        <ol className="breadcrumbs">
                            <li className="breadcrumbs-item itemslist"><Link to="/"><i className="bi bi-house"></i></Link></li>
                            <li className="breadcrumbs-item active" aria-current="page">CSIR NET</li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="mb-5">
                        <h2 className="fw-bold">CSIR NET Exam</h2>
                        <p className="text-muted">CSIR NET Exam is a national-level test for JRF & Lectureship/Assistant Professor in science subjects. Vigyan Vriksh offers online coaching, study materials, test series, & previous years’ papers to help candidates prepare.  Vigyan Vriksh covers all topics thoroughly, helping students prepare effectively for the exam.</p>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-blue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-display fs-3"></i></div>
                                    <h5 className="fw-bold">Blogs</h5>
                                    <p className="text-muted mb-0">Read Our Latest Blogs</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-pink">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-journal-text fs-3"></i></div>
                                    <h5 className="fw-bold">Online Courses</h5>
                                    <p className="text-muted mb-0">Access Our Latest Courses</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-green">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-clipboard-check fs-3"></i></div>
                                    <h5 className="fw-bold">Test Series</h5>
                                    <p className="text-muted mb-0">Practice with Our Mock Test</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-lightblue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-book fs-3"></i></div>
                                    <h5 className="fw-bold">Books</h5>
                                    <p className="text-muted mb-0">Find Preparation Books</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container my-5">    
                <h3 class="fw-bold mb-4">CSIR NET Courses</h3>
                <div class="row g-4">
                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/4_1762160824042.png&w=3840&q=75" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/super-100-csir-june-2026" class="text-dark" target="_blank">Super 100 CSIR NET June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>8 months</b> <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹10,273.30</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Live Interactive Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get c</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/super-100-csir-june-2026" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/2_1762161209603.png&w=3840&q=75" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/csir-june-2026-basic-2-advance" class="text-dark" target="_blank">Basic to Advance CSIR June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>8 months</b> <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹8,999</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Live Interactive Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get c</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/csir-june-2026-basic-2-advance" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/6_1762161421614.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/csir-june-2026-rec" class="text-dark" target="_blank">Recorded CSIR June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>8</b> months <b class="bi bi-bookmark-check"></b> <b>1000+</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹8,999</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/csir-june-2026-rec" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/8_1762161551765.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/p-csir-june-2026" class="text-dark" target="_blank">Physical Chemistry CSIR June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>8</b> months <b class="bi bi-bookmark-check"></b> <b>350+</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">Physical Chemistry CSIR June 26 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹3,081.27</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/p-csir-june-2026" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/9_1762161587902.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/o-csir-june-2026" class="text-dark" target="_blank">Organic Chemistry CSIR June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>1 year</b> <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">Organic Chemistry CSIR June 2026 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹3,081.27</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/o-csir-june-2026" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/12_1762161629658.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/i-csir-june-2026" class="text-dark" target="_blank">Inorganic Chemistry CSIR June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>1 year</b> <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">Inorganic Chemistry CSIR June 2026 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹3,081.27</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/i-csir-june-2026" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <Link to="#" class="btn btn-light border rounded-pill px-4 py-2 text-primary fw-semibold">View All Batches <i class="bi bi-arrow-right"></i></Link>
                </div>
            </section>

            <section className="container coursebox py-3">
                <div class="row g-4">
                    <h3>CSIR NET Exam</h3>
                    <p>CSIR NET is a crucial exam for aspiring research scholars and scientists. It assesses candidates' knowledge in subjects like Chemical Sciences, Earth Sciences, Life Sciences, Mathematical Sciences, and Physical Sciences. The test comprises multiple-choice questions evaluating research aptitude and subject-specific knowledge.</p>

                    <h3>What is CSIR NET?</h3>
                    <p>The CSIR NET (Council of Scientific and Industrial Research National Eligibility Test) is an exam in India for those who want to become researchers or professors in science and technology. The exam determines eligibility for Junior Research Fellowships (JRF) and Lectureships (LS) in colleges and universities. It covers subjects such as Chemical Sciences, Life Sciences, Physical Sciences, Mathematical Sciences, and Earth Sciences.</p>

                    <h3>CSIR NET Exam Details</h3> 
                    <p>The CSIR NET Exam is a crucial examination for candidates seeking research positions in various fields of science. The examination is conducted by the NTA twice a year, in June and December. The table below provides detailed information regarding the CSIR NET Exam 2025 dates, notification, application form, exam dates, admit card, answer key, result, and cut-off.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th colSpan={3}>CSIR NET Exam Details</th>
                            </tr>
                            <tr>
                                <td>Events</td>
                                <td>CSIR NET Dec 2025 (Updated)</td>
                                <td>CSIR NET June 2026 (Tentative)</td>
                            </tr>
                            <tr>
                                <td>Notification</td>
                                <td>25 Sep 2025</td>
                                <td>1st Week April 2025</td>
                            </tr>
                            <tr>
                                <td>Application Form Start Date</td>
                                <td>25 Sep 2025</td>
                                <td>1st Week April 2025</td>
                            </tr>
                            <tr>
                                <td>Last Date to Submit Application Form</td>
                                <td>24 Oct 2025 (up to 11:59 PM)</td>
                                <td>To be announced</td>
                            </tr>
                            <tr>
                                <td>Last Date for Application Fee Payment</td>
                                <td>24 June 2025 (up to 11:59 PM)</td>
                                <td>To be announced</td>
                            </tr>
                            <tr>
                                <td>Application Form Correction Window</td>
                                <td>27 – 29 Oct 2025 (up to 11:59 PM)</td>
                                <td>To be announced</td>
                            </tr>
                            <tr>
                                <td>City Intimation Slip</td>
                                <td>To be announced</td>
                                <td>4th Week may 2026 (Tentative)</td>
                            </tr>
                            <tr>
                                <td>Admit Card</td>
                                <td>To be announced</td>
                                <td>3rd Week June 2026 (Tentative)</td>
                            </tr>
                            <tr>
                                <td>Exam Date</td>
                                <td>18 Dec 2025</td>
                                <td>2nd – 3rd Week June 2026 (Tentative)</td>
                            </tr>
                            <tr>
                                <td>Provisional Answer Key</td>
                                <td>To be announced</td>
                                <td>2nd Week July 2026 (Tentative)</td>
                            </tr>
                            <tr>
                                <td>Answer Key Challenge Window</td>
                                <td>To be announced</td>
                                <td>To be announced</td>
                            </tr>
                            <tr>
                                <td>Final Answer Key</td>
                                <td>To be announced</td>
                                <td>To be announced</td>
                            </tr>
                            <tr>
                                <td>Scorecard</td>
                                <td>To be announced</td>
                                <td>To be announced</td>
                            </tr>
                            <tr>
                                <td>Final Result</td>
                                <td>To be announced</td>
                                <td>1st Week Sep 2026 (Tentative)</td>
                            </tr>
                            <tr>
                                <td>Final Cut Off</td>
                                <td>To be announced</td>
                                <td>1st Week Sep2026 (Tentative)</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3>Assistant Professor Recruitment Details</h3>
                    <p>Assistant Professor Recruitment Details provide important information about upcoming exams for various states. Candidates can check the official websites for updates on application dates, eligibility, and exam schedules. Below is a list of key recruitment exams for Assistant Professors in 2025.</p>
                    <table className="table table-bordered">
                        <tbody>
                           <tr>
                                <td>Assistant Professor Recruitment Details</td>
                            </tr>
                            <tr>
                                <td >Recruitment Name</td>
                                <td>Official Website</td>
                                <td>Exam Date </td>
                            </tr>
                            <tr>
                                <td><Link to="">OPSC Assistant Professor Recruitment 2025</Link></td>
                                <td>opsc.gov.in</td>
                                <td>August 17, 2025</td>
                            </tr>
                            <tr>
                                <td><Link to="">RPSC Assistant Professor Recruitment 2025</Link></td>
                                <td>rpsc.rajasthan.gov.in</td>
                                <td>December 2025 (Tentative)</td>
                            </tr>
                            <tr>
                                <td><Link to="">MPPSC Assistant Professor Recruitment 2025</Link></td>
                                <td>mppsc.mp.gov.in</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>Group 1: 27 July 2025</li>
                                        <li>Group 2: 1 June 2025</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td><Link to="">TPSC Assistant Professor Recruitment 2025</Link></td>
                                <td>tpsc.tripura.gov.in</td>
                                <td>December 2025 (Tentative)</td>
                            </tr>
                            <tr>
                                <td><Link to="">HPSC Assistant Professor Recruitment 2025</Link></td>
                                <td>hpsc.gov.in</td>
                                <td>4 to 12 April 2025 (For Skill Test)</td>
                            </tr>
                            <tr>
                                <td><Link to="">BPSC Assistant Professor Recruitment 2025</Link></td>
                                <td>bpsconline.bihar.gov.in</td>
                                <td>-</td>
                            </tr>
                        </tbody>
                    </table>
                    <h3>CSIR NET Eligibility</h3>
                    <p>The <Link to="">CSIR NET Eligibility Criteria</Link> outline the requirements for candidates to apply for Junior Research Fellowship (JRF) and Lectureship (LS) or Assistant Professor positions. Here is a summary of the eligibility criteria in a table format.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>CSIR NET Eligibility</td>
                            </tr>
                            <tr>
                                <td>Criteria</td>
                                <td>Details</td>
                            </tr>
                            <tr>
                                <td>Nationality</td>
                                <td>Indian citizen</td>
                            </tr>
                            <tr>
                                <td>Age Limit</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>JRF: 30 years (with relaxations up to 5 years for SC/ST/Third gender/PwD/female candidates and 3 years for OBC)</li>
                                        <li>Lectureship/Assistant Professor: No upper age limit</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>Educational Qualification</td>
                                <td>
                                    <ul className="list-unstyled">
                                        <li>Candidates need at least 55% marks (50% for SC/ST/PwD) in an MSc or equivalent degree, Integrated BS-MS, BE/BTech, BPharma, or MBBS. </li>
                                        <li>Those with an integrated MS-PhD or BSc (Hons) must have similar marks.</li>
                                        <li>Only Bachelor’s degree holders can apply for JRF, while those with a master’s degree before September 19, 1991, can apply for Lectureship.</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h3>CSIR NET Exam Pattern</h3>
                    <p>The <Link to="">CSIR NET Exam Pattern</Link> includes a three-hour test with three sections: Part A, Part B, and Part C. There is no break between the sections. The exam has multiple-choice questions (MCQs) with four options, and only one is correct. There is negative marking in the exam, with a 25% deduction for incorrect answers. Some sections may deduct up to 33%. Candidates must answer a specific number of questions in each subject. Understanding the pattern helps in better preparation for the exam.</p>
                    <ul className="list-unstyled">
                        <li>Earth, Atmospheric, Ocean and Planetary Sciences: 75 MCQs</li>
                        <li>Chemical Sciences: 75 MCQs</li>
                        <li>Life Sciences: 75 MCQs</li>
                        <li>Mathematical Sciences: 60 MCQs</li>
                        <li>Physical Sciences: 55 MCQs</li>
                    </ul>
                    <p>The <Link to="">CSIR NET Syllabus</Link> includes subjects like Physical Sciences, Chemical
                    Sciences, Life Sciences, Earth, Atmospheric, Ocean and Planetary Sciences and
                    Mathematical Sciences. It covers topics such as General Science, Research
                    Methodology, and subject-specific content. The syllabus is designed to assess
                    fundamental concepts, problem-solving skills, and research aptitude. Detailed
                    syllabi for each subject are available on the CSIR official website.</p>
                    <p>The CSIR NET syllabus covers multiple disciplines. Below is a simplified table to
                    help candidates prepare effectively by categorizing subjects, making the
                    preparation process easier and more organized.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>CSIR NET Syllabus Wise</td>
                            </tr>
                            <tr>
                                <td>Chemical Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Physical Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Earth Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Life Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Mathematical Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                        </tbody>
                    </table>
                    <h3>CSIR NET Admit Card</h3>
                    <p>The <Link to="">CSIR NET Admit Card</Link> is an essential document for the exam. It includes details like the candidate’s name, roll number, exam date, time, and venue. Candidates must download it from the official website by logging in with their credentials. A printed copy and a valid ID proof are required for entry into the exam hall. Without the admit card, candidates cannot appear for the exam.</p>
                    <h3>CSIR NET Online Test Series</h3>
                    <p>Vigyan Vriksh offers an online test series for CSIR NET covering various subjects: Life Sciences, Physical Sciences, Chemical Sciences, Mathematical Sciences, and Earth Sciences. These test series are designed to help candidates assess their preparation and improve their performance in the actual exam by providing practice questions and mock tests aligned with the CSIR NET pattern.</p>
                    <h3>CSIR NET Study Materials</h3>
                    <p>Vigyan Vriksh provides study materials for the CSIR NET 2025 exam, including notes, video lectures, and practice questions. These materials cover the full syllabus and focus on important topics. They help students understand concepts easily and improve problem-solving skills. With simple and clear explanations, Vigyan Vriksh’s study materials make learning easier. Students can prepare well and feel confident for the CSIR NET exam. These resources are designed to support effective preparation and help candidates perform better in the exam.</p>
                    <h3>How to Prepare for CSIR NET Exam?</h3>
                    <p>Preparing for CSIR NET Exam requires a strategic plan, dedication, and a clear understanding of the exam pattern and syllabus. Here's a comprehensive guide to help you prepare for the exam:</p>
                    <ul className="list-unstyled">
                        <li>Understand the Exam Pattern and Syllabus</li>
                        <li>Start preparing at least 6-8 months before the exam date.</li>
                        <li>Set clear goals for each month and divide your study material into smaller, easier parts.</li>
                        <li>Allocate time for each subject and topic, ensuring that you cover all the topics in your study plan.</li>
                        <li>Make a schedule for studying, reviewing, and practicing questions.</li>
                        <li>NCERT textbooks and study materials are recommended for all subjects.</li>
                        <li>Practice questions from previous years' CSIR NET exams can help you get familiar with the exam pattern and question types.</li>
                        <li>Practice time management skills by attempting mock tests and timed practice sessions.</li>
                        <li>Revise your study material regularly to ensure that you retain the information.</li>
                        <li>Make short notes to help you remember importantterms and concepts.</li>
                    </ul>
                    <h3>CSIR NET Previous Years Question Papers</h3>
                    <p>Vigyan Vriksh provides <Link to="">CSIR NET Previous Years Question Papers</Link> for aspirants preparing for the CSIR NET exam. These papers are valuable resources for understanding the exam pattern, difficulty level, and types of questions asked in previous years. By practicing with these papers, students can enhance their problem-solving skills and time management. Vigyan Vriksh provides access to these papers through its platform, helping students prepare well and increase their chances of doing well.</p>
                    <p>The table below provides a collection of CSIR NET previous years' question papers for various disciplines, including Life Sciences, Physical Sciences, Earth Sciences, Chemical Sciences, and Mathematical Sciences. Here is the table providing links to the previous year's question papers for each subjects.</p>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>CSIR NET Previous Years Question Papers Topic Wise</td>
                            </tr>
                            <tr>
                                <td width='50%'>Year Wise</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Topic wise Physical Chemistry</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Topic wise Organic Chemistry</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Topic wise Inorganic Chemistry</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan={2}>CSIR NET Previous Years Question Papers Subject Wise</td>
                            </tr>
                            <tr>
                                <td width='50%'>Life Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Physical Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Earth Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Chemical Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                            <tr>
                                <td>Mathematical Sciences</td>
                                <td><Link to="">Click Here</Link></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <Footer />
        </>
    );
}
export default IITGate;